// extracted by mini-css-extract-plugin
module.exports = {"note":"PendingStepPage__note__Fpq2S","preset":"PendingStepPage__preset__vYCk-","spinnerWrapper":"PendingStepPage__spinnerWrapper__fIwFA","title":"PendingStepPage__title__Q7P-0"};